// Remarks API helper.
//
// Only the DELETE operation lives on the dedicated RemarksController. The
// PUT-add operations still live on the parent controllers (Stocks /
// ApplicationForms) because adding a remark needs the parent id to associate
// the new row; deletion only needs the remark id.
//
// `api` and `apiUrl` are window-globals set by main.js, matching the pattern
// in every other *Api.js file in this directory.
class RemarkApi {
    delete(remarkId) {
        var url = apiUrl + 'remarks/' + remarkId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data;
            });
    }
}

export default RemarkApi;
